module.exports = __webpack_public_path__ + "img/shipping.05181f73.svg";